// Platform environment checks for Rover
// Works for both web and React Native platforms

export enum Environment {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
}

const checkPlatformEnvironment = (baseUrl?: string): Environment => {
  if (!baseUrl) {
    return Environment.DEVELOPMENT;
  }

  if (baseUrl.endsWith('.rover.com')) {
    return Environment.PRODUCTION;
  }

  if (baseUrl.endsWith('.roverstaging.com')) {
    return Environment.STAGING;
  }

  return Environment.DEVELOPMENT;
};

export const isProdEnv = (baseUrl?: string): boolean => {
  const env = checkPlatformEnvironment(baseUrl);
  return env === Environment.PRODUCTION;
};

export const isStagingEnv = (baseUrl?: string): boolean => {
  const env = checkPlatformEnvironment(baseUrl);
  return env === Environment.STAGING;
};

export const isDebugEnv = (baseUrl?: string): boolean => {
  const env = checkPlatformEnvironment(baseUrl);
  return env === Environment.DEVELOPMENT;
};
